module.exports = __webpack_public_path__ + "img/titleIcon1.a6370a0e.png";